// @flow
import { createUniversalRoute } from "../../utils/createUniversalRoute";
import { rebrandRoutes } from "../../pages/RebrandLayout/routes";

const createLegacyPrismicRoute = (path) => ({
  path,
  exact: true,
  name: "LegacyLayout",
  routes: [
    createUniversalRoute({
      path,
      exact: true,
      name: "MarketingLayout",
      routes: [
        createUniversalRoute({
          path: "/:item",
          name: "Custom",
        }),
      ],
    }),
  ],
});

const createLegacyStaticRoute = (path, name, config = {}) => ({
  path,
  exact: true,
  name: "LegacyLayout",
  routes: [
    createUniversalRoute({
      path,
      exact: true,
      name: "MarketingLayout",
      routes: [
        createUniversalRoute({
          path,
          name,
          ...config,
        }),
      ],
    }),
  ],
});

const createLegacyRoute = (path, name, config = {}) => ({
  path,
  name: "LegacyLayout",
  routes: [
    createUniversalRoute({
      path,
      name,
      ...config,
    }),
  ],
});

const allRoutes = [
  createLegacyPrismicRoute("/viewing-confirmed"),
  createLegacyPrismicRoute("/viewing-error"),
  createLegacyPrismicRoute("/partner-referrals"),
  createLegacyPrismicRoute("/enquiry-thank-you"),
  createLegacyPrismicRoute("/complaints-procedure"),
  createLegacyPrismicRoute("/your-home-valuation"),
  createLegacyPrismicRoute("/performance"),
  createLegacyRoute("/virtual-tours/:id", "VirtualTour"),
  createLegacyStaticRoute("/press/:item", "PressSingle"),
  createLegacyStaticRoute("/customer-stories", "CustomerStories"),
  createLegacyStaticRoute("/customer-stories/:item", "CustomerStory"),
  createLegacyStaticRoute("/guides/:item", "Guide"),
  createLegacyStaticRoute(
    "/research/:story/2017/:country/:category",
    "ResearchStory",
  ),
  createLegacyStaticRoute("/research", "Research"),
  createLegacyStaticRoute("/property-market/:area*", "AreaMarketReport"),
  createLegacyStaticRoute(
    "/how-long-will-it-take-to-sell-my-house",
    "Redirect",
    {
      props: { to: "/" },
    },
  ),
  createLegacyStaticRoute("/baby-move-calculator", "Redirect", {
    props: { to: "/" },
  }),
  createLegacyStaticRoute("/smoke-tests/:item", "SmokeTest"),
  createLegacyStaticRoute("/values", "Redirect", {
    props: { to: "/about" },
  }),
  createLegacyStaticRoute("/buying-advice", "Redirect", {
    props: { to: "/how-it-works" },
  }),
  createLegacyStaticRoute("/advance", "Redirect", {
    props: { to: "/how-it-works" },
  }),
  createLegacyStaticRoute("/agency", "Redirect", {
    props: { to: "/how-it-works" },
  }),
  createLegacyStaticRoute("/stats/:city", "Redirect", {
    props: { to: "/property-market/london" },
  }),
  createLegacyStaticRoute(
    "/stats/:city/postcode/:postcode/address/:addressId",
    "Redirect",
    {
      props: { to: "/property-market/london" },
    },
  ),
  {
    path: "/get-started",
    name: "OnboardingForm",
  },
  { path: "/support/*", name: "SupportRedirect" },
  {
    path: "/",
    name: "RebrandLayout",
    routes: rebrandRoutes,
  },
];

export const routes = allRoutes.map<*>(createUniversalRoute);
